(ns app.front.view.common.generic-licence
  "Licences, Contractor Registrations and other licentiform renewables view helpers"
  (:require [app.domain.licence.generic-model :as gl-model]
            [app.domain.util :as du]
            [app.front.ui.actions :as ui-actions]
            [app.front.view.workspace.action-subs :as action-subs]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]))

(defn renewal-box
  [{:keys [entity expired-state primary-signal-opts tr]}]
  (when (and entity (<sub [::ff/enabled? :feature-flag.id/renewal-box]))
    (let [{:keys [process-sub signal-id]} primary-signal-opts
          valid-to                        (gl-model/get-valid-to entity)
          expired?                        (or (du/in-state? expired-state entity)
                                              (date-util/before? valid-to (date-util/now)))
          renewal-ok?                     (seq (<sub [::action-subs/actions-for-signal process-sub signal-id]))]
      (when (and valid-to
                 renewal-ok?)
        [:section.border-4.border-solid.p-4.mb-8
         {:aria-label (tr [:application-wizard/renewal])
          :class      (if expired?
                        "border-status-error bg-ui-red-10"
                        "border-status-success bg-ui-white")
          :data-cy    "renewal-box"}
         [ui-actions/primary-signal-button
          (merge {:target-id (:db/id entity)
                  :tr        tr}
                 primary-signal-opts)]
         [:dl.mt-4
          [:dt.font-semibold (tr [:renewal-box/expiry-date])]
          [:dd.mt-1 ((<sub [::date-util/date-fn])
                     (date-util/to-tz valid-to (-> entity :domain/authority-group :group/tz)))]]
         [:p.mt-4 (tr [(if expired?
                         :renewal-box/licence-expired-message
                         :renewal-box/renew-before-expiry)])]]))))
